import React, { useEffect, useState } from 'react'
import style from "./FormFeedback.module.scss";
import TextField from '@mui/material/TextField';
import { Checkbox, FormControlLabel } from "@mui/material";
import axios from "axios";

const useValidation = ( value, validations ) => {
    const [isEmpty, setEmpty] = useState(true);
    const [minLengthError, setMinLengthError] = useState(false);
    const [maxLengthError, setMaxLengthError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [inputValid, setInputValid] = useState(false);

    useEffect(() => {
        for (const validation in validations) {
            switch (validation) {
                case "minLength":
                    value.length < validations[validation]
                        ? setMinLengthError(true)
                        : setMinLengthError(false);
                    break;
                case "isEmpty":
                    value ? setEmpty(false) : setEmpty(true);
                    break;
                case "maxLength":
                    value.length > validations[validation]
                        ? setMaxLengthError(true)
                        : setMaxLengthError(false);
                    break;
                case "isEmail":
                    const re =
                        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                    re.test(String(value).toLowerCase())
                        ? setEmailError(false)
                        : setEmailError(true);
                    break;
                case "isName":
                    const reName = /^[А-ЯЁа-яёA-Za-z]+$/;
                    reName.test(String(value).toLowerCase())
                        ? setNameError(false)
                        : setNameError(true);
                    break;
                case "isLastName":
                    const reLastName = /^[А-ЯЁа-яёA-Za-z]+$/;
                    reLastName.test(String(value).toLowerCase())
                        ? setLastNameError(false)
                        : setLastNameError(true);
                    break;
                case "isPhone":
                    const rePhone = /^\+\d{1} \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
                    rePhone.test(String(value).toLowerCase())
                        ? setPhoneError(false)
                        : setPhoneError(true);
                    break;
            }
        }
    }, [value]);

    useEffect(() => {
        if (
            phoneError ||
            isEmpty ||
            maxLengthError ||
            minLengthError ||
            emailError ||
            nameError ||
            lastNameError
        ) {
            setInputValid(false);
        } else {
            setInputValid(true);
        }
    }, [
        phoneError,
        isEmpty,
        maxLengthError,
        minLengthError,
        emailError,
        nameError,
        lastNameError,
    ]);

    return {
        phoneError,
        nameError,
        lastNameError,
        isEmpty,
        minLengthError,
        emailError,
        maxLengthError,
        inputValid,
    };
};
const useInput = ( initialValue, validations ) => {
    const [value, setValue] = useState(initialValue);
    const [isDirty, setDirty] = useState(false);
    const valid = useValidation(value, validations);

    const onChange = ( e ) => {
        setDirty(true);
        setValue(e.target.value);
    };

    return {
        value,
        setValue,
        onChange,
        isDirty,
        ...valid,
    };
};

export default function FormFeedback() {

    const inn = useInput("", {
        isEmpty: true,
        minLength: 10,
        maxLength: 12,
        isInn: true,
    });
    const [companyName, setCompanyName] = useState("");
    const firstName = useInput("", {isEmpty: true, minLength: 2, isName: true});
    const lastName = useInput("", {isEmpty: true, minLength: 2, isName: true});
    const email = useInput("", {isEmpty: true, minLength: 2, isEmail: true});
    const [positiveResponse, setPositiveResponse] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);

    const [comment, setComment] = useState("");
    const phoneNumber = useInput("", {
        isEmpty: true,
        minLength: 3,
        isPhone: true,
    });
    const [informationConsent, setInformationConsent] = useState(false);

    const handleInputChange = ( event ) => {
        const formattedValue = formatPhoneNumber(event.target.value);
        phoneNumber.onChange({
            target: {
                value: formattedValue,
            },
        });
    };

    const formatPhoneNumber = ( value ) => {
        const cleanedValue = value.replace(/\D/g, "");
        const limitedValue = cleanedValue.slice(0, 11);
        const matches = limitedValue.match(
            /^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/
        );

        if (matches) {
            const formattedValue = `+${matches[1]} (${matches[2]}) ${matches[3]}-${matches[4]}-${matches[5]}`;
            return formattedValue.replace(/[\s()-]+$/, "");
        }

        return value;
    };

    const [source, setSource] = useState("");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        setSource(source || "MVideo");
    }, []);
    const firstEmail = "mikhas.kroytor1@gmail.com";


    const subjectText = `Пометка: SQN-LAW.RU`;
    const messageText = `Вам поступила новая заявка!\n\nКонтактное лицо: ${firstName.value}\nEmail: ${email.value}\nТелефон: ${phoneNumber.value}\n\nКомментарий к заявке: ${comment}\n\nПредварительный расчет: `;
    const resetForm = () => {
        firstName.setValue("");
        lastName.setValue("");
        email.setValue("");
        phoneNumber.setValue("");
        setComment("");
        setInformationConsent(false);
    };
    const handleSubmit = ( e ) => {
        e.preventDefault();
        axios
            .post("https://proxy.ctrl.lc:3001/api/v1/email/", {
                email: firstEmail,
                subject: subjectText,
                message: messageText,
            })
            .then(( response ) => {
                resetForm();
                setPositiveResponse(true);

                setTimeout(() => {
                    setPositiveResponse(false);
                }, 4000);
            })
            .catch(( error ) => {
                setErrorResponse(true);
                setTimeout(() => {
                    setErrorResponse(false);
                }, 4000);
                resetForm();
            });

        resetForm();
    };

    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);

    const closeModal1 = () => {
        setIsOpen1(false);
    };

    const closeModal2 = () => {
        setIsOpen2(false);
    };

    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    const closeConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };
    const closeErrorModal = () => {
        setIsErrorModalOpen(false);
    };

    return (
        <>
            <form className={style.form} onSubmit={handleSubmit}>
                <div className={style.container}>
                    <div className={style.inputContainer}>
                        <TextField sx={{input: {color: 'white'}}} className={style.inputName} label="Имя"
                                   variant="outlined"
                                   onChange={( e ) => firstName.onChange(e)}
                                   value={firstName.value}/>
                        {firstName.minLengthError &&
                            firstName.isEmpty &&
                            firstName.nameError && (
                                <div className={style.inputIncorrect}>
                                    Это поле обязательно для заполнения*
                                </div>
                            )}
                    </div>
                    <div className={style.inputContainer}>
                        <TextField sx={{input: {color: 'white'}}} className={style.inputName} label="Фамилия"
                                   variant="outlined"
                                   onChange={( e ) => lastName.onChange(e)}
                                   value={lastName.value}/>
                    </div>
                </div>
                <div className={style.container}>
                    <div className={style.inputContainer}>
                        <TextField sx={{input: {color: 'white'}}} className={style.inputName}
                                   label="Email* (обязательно)" variant="outlined"
                                   value={email.value}
                                   onChange={( e ) => email.onChange(e)}/>

                        {email.minLengthError &&
                            email.isEmpty &&
                            email.emailError && (
                                <div className={style.inputIncorrect}>
                                    Это поле обязательно для заполнения*
                                </div>
                            )}
                    </div>
                    <div className={style.inputContainer}>
                        <TextField sx={{input: {color: 'white'}}} className={style.inputName} label="+7 (___) ___-__-__"
                                   variant="outlined"
                                   value={phoneNumber.value}
                                   onChange={( e ) => {
                                       phoneNumber.onChange(e);
                                       const cleanedValue = e.target.value.replace(/\D/g, "");

                                       handleInputChange({target: {value: cleanedValue}});
                                   }}/>
                        {phoneNumber.minLengthError &&
                            phoneNumber.isEmpty &&
                            phoneNumber.phoneError && (
                                <div className={style.inputIncorrect}>
                                    Это поле обязательно для заполнения*
                                </div>
                            )}
                    </div>
                </div>
                <div>
                    <TextField sx={{input: {color: 'white'}}} className={style.inputName}
                               label="Напишите, чем мы можем вам помочь" variant="outlined"
                               value={comment}
                               onChange={( e ) => setComment(e.target.value)}/>
                </div>
                <div>
                    <div className={style.checkbox}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={informationConsent}
                                    onChange={( e ) => setInformationConsent(e.target.checked)}
                                    sx={{
                                        color: 'white',
                                        '&.Mui-checked': {
                                            color: 'red',
                                        },
                                    }}
                                />
                            }
                            label="Я согласен с обработкой моих данных в соответствии с требованием Sine Qua Non*"
                            sx={{
                                '& .MuiTypography-root': {
                                    color: 'white',
                                    fontSize: '16px',
                                    '@media (max-width:800px)': {
                                        fontSize: '15px',
                                    },
                                    '@media (max-width:600px)': {
                                        fontSize: '13px',
                                    },

                                },
                            }}
                            className={style.checkboxLabel}
                        />

                    </div>
                    <div className={style.button}>
                        <button
                            disabled={
                                !firstName.inputValid ||
                                !lastName.inputValid ||
                                !email.inputValid ||
                                !phoneNumber.inputValid ||
                                !informationConsent
                            }
                            type="submit"
                        >
                            Отправить
                        </button>
                    </div>
                </div>
                {/*{positiveResponse && (*/}
                {/*    <div className={style.positiveResponseContainer}>*/}
                {/*        <div className={style.positiveResponse}>*/}
                {/*            <img src={PositiveIcon} alt=""/>*/}
                {/*            <h3 className={style.positiveResponse}>Заявка принята</h3>*/}
                {/*            <p className={style.positiveResponse}>*/}
                {/*                Мы скоро Вам перезвоним*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*)}*/}
                {/*{errorResponse && (*/}
                {/*    <div className={style.positiveResponseContainer}>*/}
                {/*        <div className={style.positiveResponse}>*/}
                {/*            <img src={ErrorIcon} alt=""/>*/}
                {/*            <h3 className={style.positiveResponse}>*/}
                {/*                Что-то пошло не так*/}
                {/*            </h3>*/}
                {/*            <p className={style.positiveResponse}>*/}
                {/*                Попробуйте еще раз позже*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*)}*/}
            </form>
        </>
    )
}
